import { Navigate } from "react-router-dom";

// Account security lives in Settings → Security (the stepped 2FA wizard + active
// sessions). This legacy route redirects there so there's a single, consistent page.
export function Security() {
  return <Navigate to="/settings/security" replace />;
}
